// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from './environment';

export const environment: Environment = {
    production: false,
    WEATHER_API_URL: 'https://api.weatherapi.com/v1/current.json?key=712079125e9a4911b7a225742223004&q=de+bilt',

    all_messages: [],
    all_mails: [],
    gaToken: null
};
